﻿import React from 'react';
import { CardItemValue } from "../CardItemValue";
import { styled } from "@mui/material/styles";

const Root = styled(CardItemValue)(({ theme }) => ({
  color: theme.palette.info.main,
}));

type CardItemValueInfoProps = React.ComponentPropsWithoutRef<'span'>;

const CardItemValueInfo = (props: CardItemValueInfoProps) => {
  return <Root {...props} />
}

export { CardItemValueInfo }
